<template><div><h1>VUX V2.3.6 released</h1>
<h2><a href="/en/components/cell.html">Cell</a></h2>
<ul><li>[feature] Support arrow less variables</li>
</ul>
<h2><a href="/en/components/datetime.html">Datetime</a></h2>
<ul><li>[feature] Add slot:title</li>
<li>[feature] Add prop:readonly</li>
<li>[fix] Fix a bug caused by scroller #1406</li>
</ul>
<h2><a href="/en/components/inline-calendar.html">InlineCalendar</a></h2>
<ul><li>[change] render-function params day => date #1361</li>
</ul>
<h2><a href="/en/components/popup-radio.html">PopupRadio</a></h2>
<ul><li>[feature] Add prop:readonly</li>
<li>[feature] Add slot:icon</li>
</ul>
<h2><a href="/en/components/search.html">Search</a></h2>
<ul><li>[feature] Add method:setBlur</li>
</ul>
<h2><a href="/en/components/spinner.html">Spinner</a></h2>
<ul><li>[feature] Support prop:size #1447</li>
</ul>
<h2><a href="/en/components/string.html">String</a></h2>
<ul><li>[enhance] trim is now alias to stringTrim</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.3.6 released | VUX - Vue.js Mobile UI Component Framework","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.3.6-104.vue?76ef0f9a